import angular from 'angular';
import utils from '@/shared/utils/adminpulse';
import moment from 'moment';

const dayPrefix = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];

const calculateLineTotal = line => {
  let total = 0;
  if (!line.skipMorning) {
    total += (line.endMorning || 0) - (line.startMorning || 0);
  }
  if (!line.skipAfternoon) {
    total += (line.endAfternoon || 0) - (line.startAfternoon || 0);
  }
  return total;
};
const getValidationErrors = line => {
  const errors = {};

  const startMorning = line.startMorning || 0;
  const endMorning = line.endMorning || 0;
  const startAfternoon = line.startAfternoon || 0;
  const endAfternoon = line.endAfternoon || 0;

  const skipMorning = startMorning === endMorning;
  const skipAfternoon = startAfternoon === endAfternoon;

  if (!skipMorning && startMorning > endMorning) {
    errors.startMorning = true;
    errors.endMorning = true;
  }
  if (!skipAfternoon && startAfternoon > endAfternoon) {
    errors.startAfternoon = true;
    errors.endAfternoon = true;
  }
  if (!skipMorning && !skipAfternoon && endMorning > startAfternoon) {
    errors.endMorning = true;
    errors.startAfternoon = true;
  }
  return errors;
};

const emptyTimeSpan = '00:00:00';
angular
  .module('cloudX')
  .controller('EmployeeTimeTableDialogCtrl', [
    '$element',
    '$translate',
    '$http',
    'appUrls',
    'dataCache',
    'flySvc',
    'close',
    'employee',
    'timeTable',
    employeeTimeTableDialogCtrl,
  ]);
function employeeTimeTableDialogCtrl(
  $element,
  $translate,
  $http,
  appUrls,
  dataCache,
  flySvc,
  close,
  employee,
  timeTable,
) {
  var vm = this;
  vm.invalid = false;
  vm.startDate = null;
  vm.prevStartDate = null;
  vm.saving = false;
  vm.employee = employee;
  vm.weekTotal = 0;
  vm.homeWorkingTotal = 0;
  vm.timeTable = {
    productivityPercentage: timeTable?.productivityPercentage ?? 100,
  };

  vm.dayLabels = [
    $translate.instant('Sunday'),
    $translate.instant('Monday'),
    $translate.instant('Tuesday'),
    $translate.instant('Wednesday'),
    $translate.instant('Thursday'),
    $translate.instant('Friday'),
    $translate.instant('Saturday'),
  ];

  vm.save = function() {
    if (!vm.validate()) return;

    const model = vm.data.reduce(
      (result, line) => {
        const prefix = dayPrefix[line.day];
        result[`${prefix}StartMorning`] = utils.minutesToTimeSpan(
          line.skipMorning ? 0 : line.startMorning,
        );
        result[`${prefix}EndMorning`] = utils.minutesToTimeSpan(
          line.skipMorning ? 0 : line.endMorning,
        );
        result[`${prefix}StartAfternoon`] = utils.minutesToTimeSpan(
          line.skipAfternoon ? 0 : line.startAfternoon,
        );
        result[`${prefix}EndAfternoon`] = utils.minutesToTimeSpan(
          line.skipAfternoon ? 0 : line.endAfternoon,
        );
        result[`${prefix}HomeWorkingMinutes`] = line.homeWorking;
        return result;
      },
      {
        employeeId: employee.employeeID,
        dateFrom: vm.startDate,
        productivityPercentage: vm.timeTable.productivityPercentage || 100,
      },
    );
    vm.saving = true;
    $http.put(`${appUrls.api}/api/employee/TimeTable`, model).then(
      ({ data }) => {
        if (!dataCache.getArray('employeeTimeTables')) {
          dataCache.update('employeeTimeTables', true);
          $translate.refresh(); //Reload translations (a new resource was probably added)
        }
        close(data, 500);
        $element.modal('hide');
        vm.saving = false;
      },
      function(error) {
        flySvc.error(error.data.code, error.data.parameters);
        vm.saving = false;
      },
    );
  };
  vm.cancel = function() {
    close(null, 500);
  };

  vm.lineChanged = function(line) {
    line.skipMorning = (line.startMorning || 0) === (line.endMorning || 0);
    line.skipAfternoon = (line.startAfternoon || 0) === (line.endAfternoon || 0);
    line.total = calculateLineTotal(line);
    line.homeWorking = Math.max(0, Math.min(line.total, line.homeWorking));
    line.error = getValidationErrors(line);
    const wasInvalid = !!line.invalid;
    line.invalid = Object.keys(line.error).length > 0;
    if (line.invalid) {
      vm.invalid = true;
    } else if (wasInvalid && vm.invalid) {
      vm.validate(); //Run full validation
    }
    vm.weekTotal = vm.data.reduce((sum, line) => sum + line.total, 0);
    vm.homeWorkingTotal = vm.data.reduce((sum, line) => sum + line.homeWorking, 0);
  };
  vm.startDateChanged = function() {
    if (!vm.startDate) {
      vm.invalid = true;
    } else if (vm.invalid) {
      vm.validate(); //Run full validation
    }
  };
  vm.validate = function() {
    if (!vm.startDate) {
      vm.invalid = true;
      return false;
    }
    if (vm.timeTable.productivityPercentage < 0 || vm.timeTable.productivityPercentage > 100) {
      vm.invalid = true;
      return false;
    }
    vm.invalid = false;
    vm.data.forEach(line => {
      line.error = getValidationErrors(line);
      line.invalid = Object.keys(line.error).length > 0;
      if (line.invalid) {
        vm.invalid = true;
      }
    });
    return !vm.invalid;
  };

  //Init timetable
  vm.data = [];
  for (let i = 1; i < 8; i += 1) {
    const day = i % 7;
    const line = {
      day,
      label: vm.dayLabels[day],
      total: 0,
    };
    if (timeTable) {
      const prefix = dayPrefix[day];
      line.startMorning = utils.timeSpanToMinutes(timeTable[`${prefix}StartMorning`]);
      line.endMorning = utils.timeSpanToMinutes(timeTable[`${prefix}EndMorning`]);
      line.startAfternoon = utils.timeSpanToMinutes(timeTable[`${prefix}StartAfternoon`]);
      line.endAfternoon = utils.timeSpanToMinutes(timeTable[`${prefix}EndAfternoon`]);
      line.homeWorking = parseInt(timeTable[`${prefix}HomeWorkingMinutes`]);
    } else {
      //New timetable
      if (day === 0 || day === 6) {
        //Weekend
        line.startMorning = null;
        line.endMorning = null;
        line.startAfternoon = null;
        line.endAfternoon = null;
        line.homeWorking = 0;
      } else {
        line.startMorning = 480; //8:00
        line.endMorning = 720; //12:00
        line.startAfternoon = 780; //13:00
        line.endAfternoon = 1020; //17:00
        line.homeWorking = 0;
      }
    }
    vm.lineChanged(line);
    vm.data.push(line);
  }
  if (timeTable) {
    vm.prevStartDate = moment.utc(timeTable.dateFrom).toDate();
  }
}
